// const isProdMode = process.env.NODE_ENV === 'production'
const baseUrl = '/frontInterface'

module.exports = {
  baseUrl
}
